export default __webpack_public_path__ + "static/media/personal-photo_small.bd2eed92.jpg";